import React from 'react';
import { houseModes } from '../../../data/houseModes';
import type { HouseModeConfig } from '../../../types/settings';
interface HouseModesTableProps {
  modes: HouseModeConfig[];
  onChange: (next: HouseModeConfig) => void;
}
const OPTIONS = {
  sound: ['aan', 'zacht', 'uit'],
  notifications: ['alle', 'belangrijk', 'alleen veiligheid'],
  initiative: ['normaal', 'laag', 'uit'],
  wall: ['vol', 'gedimd', 'klok']
} as const;
type Field = keyof typeof OPTIONS;
const COLUMNS: {
  field: Field;
  label: string;
}[] = [{
  field: 'sound',
  label: 'Geluid'
}, {
  field: 'notifications',
  label: 'Meldingen'
}, {
  field: 'initiative',
  label: 'Initiatief'
}, {
  field: 'wall',
  label: 'Wandscherm'
}];

/** What each house mode changes. Veiligheidsmeldingen always come through — not editable. */
export function HouseModesTable({
  modes,
  onChange
}: HouseModesTableProps) {
  return <div className="no-scrollbar overflow-x-auto rounded-3xl border border-white/[0.07] bg-night-900" data-id="element-66" data-mp="20ya3ms9lohv1">
      <table className="w-full min-w-[860px] text-left text-[14px]" data-id="element-67" data-mp="rcx1c7xhkp7n">
        <thead data-id="element-68" data-mp="rf9tfdwykfyf">
          <tr className="border-b border-white/[0.06] text-[12px] text-ink-muted" data-id="element-69" data-mp="melrvyb3sgpy">
            <th scope="col" className="px-5 py-3 font-medium" data-id="element-70" data-mp="mgq73cegd25j">Modus</th>
            {COLUMNS.map(c => <th key={c.field} scope="col" className="px-3 py-3 font-medium" data-id="element-71" data-mp="wcjhap4p8jk5">{c.label}</th>)}
            <th scope="col" className="px-5 py-3 font-medium" data-id="element-72" data-mp="1ac18fb5gw8wo">Gaat aan bij</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-white/[0.05]" data-id="element-73" data-mp="15drdn1nnnabl">
          {modes.map(m => {
          const info = houseModes.find(h => h.id === m.mode);
          const Icon = info?.icon;
          return <tr key={m.mode} data-id="element-74" data-mp="1f2rgwx96wrvl">
                <th scope="row" className="px-5 py-3 font-normal" data-id="element-75" data-mp="1f3t1bsc3iqpz">
                  <span className="flex items-center gap-2.5 font-medium text-ink" data-id="element-76" data-mp="1t3u277sd1y5g">
                    {Icon && <Icon className="h-4 w-4 text-ink-muted" strokeWidth={1.75} aria-hidden data-id="element-77" data-mp="1p206ldx0vkc5" />}
                    {m.mode}
                  </span>
                  {info && <span className="mt-0.5 block text-[12px] text-ink-muted" data-id="element-78" data-mp="1w2khu457dn2t">{info.description}</span>}
                </th>
                {COLUMNS.map(c => <td key={c.field} className="px-3 py-3" data-id="element-79" data-mp="261t8oo4rulky">
                    <label className="sr-only" htmlFor={`${m.mode}-${c.field}`} data-id="element-80" data-mp="2at1jnolr2f08">
                      {c.label} in {m.mode}
                    </label>
                    <select id={`${m.mode}-${c.field}`} value={m[c.field]} onChange={e => onChange({
                ...m,
                [c.field]: e.target.value
              } as HouseModeConfig)} className="h-8 rounded-full border border-white/10 bg-white/[0.03] px-3 text-[13px] text-ink-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60" data-id="element-81" data-mp="2eun1zph1zlht">
                      {OPTIONS[c.field].map(o => <option key={o} value={o} className="bg-night-900" data-id="element-82" data-mp="zeeinwr1vmvx">
                          {o}
                        </option>)}
                    </select>
                  </td>)}
                <td className="px-5 py-3 text-[13px] text-ink-muted" data-id="element-83" data-mp="33w3y9q79xb4s">{m.trigger}</td>
              </tr>;
        })}
        </tbody>
      </table>
    </div>;
}